export default "__VITE_ASSET__4ac6db97__"